"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleImportFromCsv = handleImportFromCsv;
/* eslint-disable @typescript-eslint/no-explicit-any */
const Dialogs_1 = require("@juvare/data-import-ui/Dialogs");
const material_1 = require("@mui/material");
const react_1 = __importDefault(require("react"));
function handleImportFromCsv(t, props, storage, reload) {
    (0, Dialogs_1.showDataImportDialog)({
        title: t('classifiers.importConfigurationValue', { value: props.title }),
        init: async () => {
            return {};
        },
        content: (react_1.default.createElement(material_1.Box, { sx: { pb: 2 } },
            react_1.default.createElement(material_1.Alert, { severity: 'info' }, t('classifiers.importConfigurationValueMessage')))),
        validateRow: async (row) => {
            if (props.mapCsvRowToData) {
                const mappedRow = await props.mapCsvRowToData(row);
                if (mappedRow.object && mappedRow.object.data) {
                    if (mappedRow.object.id != null && mappedRow.object.id.length === 36) {
                        // id looks like a UUID, try to use it
                        try {
                            await storage.get(mappedRow.object.id);
                            // found
                            return { ...row, object: { id: mappedRow.object.id, data: mappedRow.object.data } };
                            // eslint-disable-next-line @typescript-eslint/no-unused-vars
                        }
                        catch (error) {
                            // not found
                            row.warnings.push(t('classifiers.importClassifierNotFoundByIdMessage'));
                            return { ...row, object: { data: mappedRow.object.data } };
                        }
                    }
                    else if (typeof mappedRow.object.data.name === 'string') {
                        // find id by name
                        const name = mappedRow.object.data.name;
                        const result = await storage.list({
                            filter: [
                                {
                                    column: 'name',
                                    op: '=',
                                    value: name,
                                },
                            ],
                        });
                        if (result.rows.length === 0) {
                            return { ...row, object: { data: mappedRow.object.data } };
                        }
                        // Collect case-sensitive rows
                        const rows = result.rows.filter((r) => r.columns.name === name);
                        if (rows.length === 1) {
                            return {
                                ...row,
                                object: { id: rows[0].id, data: mappedRow.object.data },
                            };
                        }
                        else {
                            return {
                                ...row,
                                errors: [...row.errors, t('classifiers.importFoundRecordWithThisNameMessage', { name })],
                                object: undefined,
                            };
                        }
                    }
                    else {
                        return {
                            ...row,
                            errors: [...row.errors, t('classifiers.importNameFieldIsNotMappedMessage')],
                            object: undefined,
                        };
                    }
                }
            }
            return row;
        },
        validateRows: async (rows) => {
            if (props.mapCsvRowToData) {
                const names = [];
                return rows.map((r) => {
                    if (r.object && r.object.data && r.object.data.name) {
                        const name = r.object.data.name.toLowerCase();
                        if (!names.includes(name)) {
                            names.push(name);
                            return r;
                        }
                        else {
                            return {
                                ...r,
                                errors: [...r.errors, t('classifiers.importRecordAlreadyExistsMessage', { name: r.object.data.name })],
                            };
                        }
                    }
                    else {
                        return r;
                    }
                });
            }
            return rows;
        },
        importRow: (row) => {
            if (row.object && row.object.data) {
                if (row.object.id != null) {
                    return storage
                        .post({
                        action: 'update',
                        id: row.object.id,
                        data: row.object.data,
                    })
                        .then(() => row);
                }
                else {
                    return storage
                        .post({
                        action: 'create',
                        data: row.object.data,
                    })
                        .then(() => row);
                }
            }
            else {
                return Promise.resolve(row);
            }
        },
        onClose: () => reload(),
    });
}
